import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import subscriptionService from "../../api/subscriptionService";

export const subscriptionData = createAsyncThunk(
  "subscription/subscriptionData",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await subscriptionService.subscriptionData(payload);

      return {
        subscriptionData: response?.data?.data?.plans || [],
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  subscriptionDataItems: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(subscriptionData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(subscriptionData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionDataItems = action.payload.subscriptionData || [];
      })

      .addCase(subscriptionData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage =
          action.payload || "Failed to fetch subscription data.";
        state.actionFlag = "GET_SUBSCRIPTION_DATA_FAILED";
      });
  },
});

export default subscriptionSlice.reducer;
